import { createSvgIcon } from '@mui/material';

interface IProps {
  bgColor?: string;
  fillColor?: string;
  [x: string]: any;
}

const ImageIcon = (props: IProps) => {
  const { bgColor = '#E53935', fillColor = 'white', ...rest } = props;
  const IconCmp = createSvgIcon(
    <>
      <rect width="32" height="32" rx="6" fill={bgColor} />
      <g clip-path="url(#clip0_1399_34398)">
        <path
          d="M24.7227 18.475C24.1902 17.9162 23.0982 17.5975 21.5547 17.5975C20.7297 17.5975 19.7719 17.677 18.7339 17.863C18.098 17.2515 17.5189 16.5835 17.0037 15.8672C16.6047 15.3347 16.2582 14.7497 15.9387 14.1902C16.5514 12.3272 16.8439 10.81 16.8439 9.71874C16.8439 8.49474 16.3917 7.21674 15.0874 7.21674C14.6884 7.21674 14.2887 7.45674 14.0757 7.80249C13.4907 8.84049 13.7569 11.1025 14.7679 13.3382C14.3874 14.4816 13.9613 15.6092 13.4907 16.7185C13.0647 17.7302 12.5854 18.7682 12.0529 19.726C9.12568 20.8975 7.23569 22.255 7.02269 23.3185C6.94319 23.7182 7.07594 24.091 7.36919 24.3835C7.47569 24.4637 7.84843 24.7832 8.48668 24.7832C10.4292 24.7832 12.4789 21.6422 13.5169 19.753C14.3157 19.4867 15.1144 19.2205 15.9124 19.0075C16.7544 18.7788 17.6072 18.5924 18.4677 18.4487C20.5167 20.2847 22.3264 20.578 23.2317 20.578C24.3492 20.578 24.7489 20.125 24.8817 19.753C25.1217 19.273 24.9619 18.7412 24.7227 18.475ZM23.6577 19.2475C23.5774 19.6465 23.1777 19.9127 22.6197 19.9127C22.4599 19.9127 22.3272 19.8857 22.1667 19.8595C21.1557 19.6195 20.1972 19.114 19.2394 18.3152C19.9779 18.1904 20.7255 18.1281 21.4744 18.1292C22.0339 18.1292 22.5132 18.1555 22.8319 18.2357C23.2047 18.3152 23.7904 18.5552 23.6569 19.2467L23.6577 19.2475ZM18.0147 17.9965C17.272 18.1356 16.5352 18.3043 15.8059 18.502C15.1699 18.6673 14.5396 18.8537 13.9159 19.0607C14.2401 18.4328 14.5421 17.7937 14.8212 17.1445C15.1407 16.399 15.4062 15.6272 15.6732 14.9087C15.9387 15.361 16.2319 15.814 16.5244 16.213C17.0027 16.8227 17.4997 17.4175 18.0147 17.9965ZM14.5287 8.09499C14.5757 8.0007 14.6477 7.92113 14.7369 7.86493C14.826 7.80872 14.9288 7.77805 15.0342 7.77624C15.5929 7.77624 15.6994 8.41449 15.6994 8.92074C15.6994 9.77199 15.4332 11.0762 14.9809 12.5665C14.2084 10.4905 14.1559 8.76099 14.5287 8.09499ZM11.6007 20.4977C10.2432 22.7335 8.93893 24.1172 8.14093 24.1172C7.99695 24.1181 7.85669 24.0715 7.74193 23.9845C7.58218 23.8247 7.50194 23.6387 7.55519 23.4257C7.71493 22.627 9.25843 21.5095 11.6007 20.4977Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1399_34398">
          <rect
            width="18"
            height="18"
            fill={fillColor}
            transform="translate(7 7)"
          />
        </clipPath>
      </defs>
    </>,
    'ImageIcon',
  );
  return <IconCmp viewBox={'0 0 32 32'} {...rest} />;
};
export default ImageIcon;
